import React from 'react';
import classNames from 'classnames';

interface ComponentProps {
  title: string;
  description?: string;
  subDescription?: string;
  className?: string;
  headerRight?: React.ReactNode;
  children: React.ReactNode;
}

const SectionCard: React.FC<ComponentProps> = ({ title, description, subDescription, className, headerRight, children }) => {
  const localClassName = classNames('section-card-container', className);
  return (
    <div className={localClassName}>
      <div className="section-card-header">
        <h5 className="section-card-title">{title}</h5>
        {headerRight && <div className="section-card-header-right">{headerRight}</div>}
      </div>
      {description && <p className="section-card-description">{description}</p>}
      {subDescription && <p className="section-card-sub-description">{subDescription}</p>}
      <div>{children}</div>
    </div>
  );
};

export default SectionCard;
